import React from "react";
import {
  CatalogPage,
  designingCatalogConfig,
} from "../features/design-catalog";
import SEO from "../components/SEO";

const Designing = () => (
  <>
    <SEO
      title="Designing Services"
      description="Professional designing services for all your advertising and marketing needs. Get custom graphic design, brand assets, social media creatives, print design, and more at Indorinama."
      keywords="graphic design services, brand design, logo design, social media design, print design, advertising design, creative design services, India"
      url="https://indorinama.com/designing"
      type="website"
    />
    <CatalogPage config={designingCatalogConfig} />
  </>
);

export default Designing;